import { getCookie } from 'cookies-next/client'

import { COOKIE_RX_CAMPAIGN_CODE_NAME } from '../cookies'

export const rxGetCampaignCode = (): string | undefined => {
  const cookieValue = getCookie(COOKIE_RX_CAMPAIGN_CODE_NAME)?.split('&')

  const campaignCookieValue = cookieValue?.map((cValue) => cValue.split('='))

  if (campaignCookieValue) {
    const campaignCodes = Object.fromEntries(campaignCookieValue) as Record<
      string,
      string
    >

    return (
      campaignCodes.adword || campaignCodes.newsletter || campaignCodes.campaign
    )
  }

  return undefined
}
